module.exports = __webpack_public_path__ + "static/media/svg6.7fc53ee5.svg";